import { IonButtons, IonToolbar, useIonPopover } from '@ionic/react';
import { useFirmwareUpdate } from 'components/useUpdateOverlay';
import { FunctionComponent } from 'react';
import React from 'react';
import { useAuthService } from '../../../services/Authentication';
import OptionsPopOver from './OptionsPopOver';
import DynamicButton from 'components/buttons/DynamicButton';

interface ToolbarProps {
  bleConnected: boolean;
  editRider?: () => void;
  editBoard?: () => void;
  openSettings?: () => void;
  onOpenDebugModal?: () => void;
  onDeleteUser?: () => void;
  onOpenFirmwareTest?: () => void;
}

const Toolbar: FunctionComponent<ToolbarProps> = ({
  bleConnected,
  editRider,
  editBoard,
  openSettings,
  onOpenDebugModal,
  onDeleteUser,
  onOpenFirmwareTest,
}) => {
  const AuthService = useAuthService();
  const { checkForUpdates } = useFirmwareUpdate();

  // This hook creates a popover for the menu.
  const [showOptions, dismiss] = useIonPopover(OptionsPopOver, {
    onHide: () => dismiss(),
    checkUpdates: bleConnected
      ? () => checkForUpdates({ force: true })
      : undefined,
    logOut: AuthService.signOut.bind(AuthService),
    editRider: editRider,
    editBoard: editBoard,
    openSettings: openSettings,
    onOpenDebugModal: onOpenDebugModal,
    onDeleteUser: onDeleteUser,
    onOpenFirmwareTest: onOpenFirmwareTest,
  });

  const handleOptionsClick = (event: React.MouseEvent) => {
    showOptions({
      event: event.nativeEvent,
    });
  };

  return (
    <IonToolbar className="notchSafe">
      {/* SETTING BUTTON */}
      <IonButtons slot="primary">
        <DynamicButton
          text=""
          fill="clear"
          iconName="ToolUpIcon"
          buttonType="icon-full"
          color="primary"
          size="large"
          onClick={handleOptionsClick}
        />
      </IonButtons>
    </IonToolbar>
  );
};

export default Toolbar;
